import React from "react";
import { useDispatch } from "react-redux";
import { Box, CardContent, Grid } from "@mui/material";

import ModuleMediaLauncher from "./ModuleMediaLauncher";
import ModuleMediaPlayer from "./ModuleMediaPlayer";
import ModuleMediaHTMLRender from "./ModuleMediaHTMLRender";
import ModuleMediaDocumentViewer from "./ModuleMediaDocumentViewer";
import ModuleMediaAudioPlayer from "./ModuleMediaAudioPlayer";

import { updateModuleEnrolment } from "../../../../actions/tmsActions";

function ModuleMedia({ media, isActive, moduleId, onComplete }) {
    const dispatch = useDispatch();

    const handleComplete = () => {
        dispatch(
            updateModuleEnrolment(
                "C-TMS",
                moduleId,
                { status: "completed", score: 100 },
                onComplete
            )
        );
    };

    let mediaAction = "";

    switch (media.type) {
        case "e-learning":
            const handleSave = () => {
                dispatch(
                    updateModuleEnrolment(
                        "C-TMS",
                        moduleId,
                        { dateLastLaunched: new Date().toISOString() },
                        onComplete
                    )
                );
            };
            mediaAction = (
                <ModuleMediaLauncher
                    media={media}
                    moduleId={moduleId}
                    onSave={handleSave}
                />
            );
            break;

        case "video":
            mediaAction = (
                <ModuleMediaPlayer
                    media={media}
                    moduleId={moduleId}
                    onComplete={handleComplete}
                />
            );
            break;

        case "text":
            mediaAction = (
                <ModuleMediaHTMLRender
                    media={media}
                    moduleId={moduleId}
                    onComplete={handleComplete}
                />
            );
            break;

        case "document":
            mediaAction = (
                <ModuleMediaDocumentViewer
                    media={media}
                    moduleId={moduleId}
                    onComplete={handleComplete}
                />
            );
            break;

        case "audio":
            mediaAction = (
                <ModuleMediaAudioPlayer
                    media={media}
                    moduleId={moduleId}
                    onComplete={handleComplete}
                />
            );
            break;

        default:
            break;
    }

    return (
        <CardContent>
            <Box className="card-content">
                <Grid container spacing={4}>
                    {isActive && (
                        <Grid item xs={12} sm={12} md={12}>
                            {mediaAction}
                        </Grid>
                    )}
                </Grid>
            </Box>
        </CardContent>
    );
}

export default ModuleMedia;
